/*eslint-disable no-unsafe-optional-chaining */
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import ToastMessage from '../../common/ToastMessage';
import APIEndpoints from 'src/Admin/api/APIEndpoints';
import { axiosInstance } from 'src/api/axios';
import {
  setReportCategory,
  setReportName,
  setReportCategoryDropdownOptions,
  setReportNameDropdownOptions,
  resetGenerateReport,
  setDynamicFields,
  setIsServerErrorOnDynamicForm,
  resetBlobData,
} from '../../../../redux/admin/reportsSlice';

const useGenerateReport = () => {
  const dispatch = useDispatch();
  const { generateReport } = useSelector((state) => state?.reports);
  const { userRoleAndPermissions, userData } = useSelector(
    (state) => state?.user,
  );
  const navigate = useNavigate();

  const getCommonDataForReportCategoryAndName = (
    arr1 = [],
    arr2 = [],
    permissionLevel = '',
  ) => {
    const mainArr = [...arr1];
    const compareArr = [...arr2];
    const formattedData = [];
    mainArr.map((item1) => {
      compareArr.some((item2) => {
        if (item1?.label?.trim() === item2[permissionLevel]) {
          formattedData.push({
            label: item2[permissionLevel],
            value: item1?.value,
            reportName: item1?.reportName,
            reportOid: item1?.reportOid,
          });
          return true;
        }
        return;
      });
      return;
    });
    return formattedData;
  };

  const getReportNameList = (DATA) => {
    const reportNameData = [];
    if (DATA?.length > 0) {
      console.log('DATA', DATA);
      DATA.map((item) => {
        if (item?.reportName && item?.reportPath) {
          reportNameData.push({
            label: item?.reportName,
            value: btoa(String(item?.reportPath)),
            reportName: btoa(String(item?.reportName)),
            reportOid: item?.oid,
          });
        }
        return;
      });
      if (userData?.SuperUser === true) {
        dispatch(setReportNameDropdownOptions(reportNameData));
        return reportNameData;
      } else {
        const permissionEnabledFilterData = [
          ...userRoleAndPermissions.filter((item) => {
            if (
              (item?.PermissionLevel2 !== null ||
                item?.PermissionLevel2 !== '') &&
              item?.PermissionLevel2Enabled === true
            ) {
              return true;
            } else {
              return false;
            }
          }),
        ];
        const filterPermittedDataBasedOnPeremission =
          getCommonDataForReportCategoryAndName(
            [...reportNameData],
            [...permissionEnabledFilterData],
            'PermissionLevel2',
          );
        dispatch(
          setReportNameDropdownOptions([
            ...filterPermittedDataBasedOnPeremission,
          ]),
        );
        return [...filterPermittedDataBasedOnPeremission];
      }
    }
    return [];
  };

  const getReportCategoryList = (DATA) => {
    const reportCategoryData = [];
    if (DATA?.length > 0) {
      const getUniqueData = [
        ...new Map(DATA.map((item) => [item['category'], item])).values(),
      ];
      getUniqueData.map((item) => {
        if (item?.category) {
          reportCategoryData.push({
            label: item?.category,
            value: item?.oid,
          });
        }
        return;
      });
      if (userData?.SuperUser === true) {
        dispatch(setReportCategoryDropdownOptions([...reportCategoryData]));
        return reportCategoryData;
      } else {
        const permissionEnabledFilterData = [
          ...userRoleAndPermissions.filter((item) => {
            if (
              (item?.PermissionLevel1 !== null ||
                item?.PermissionLevel1 !== '') &&
              item?.PermissionLevel1Enabled === true
            ) {
              return true;
            } else {
              return false;
            }
          }),
        ];
        const filterPermittedDataBasedOnPeremission =
          getCommonDataForReportCategoryAndName(
            [...reportCategoryData],
            [...permissionEnabledFilterData],
            'PermissionLevel1',
          );
        dispatch(
          setReportCategoryDropdownOptions([
            ...filterPermittedDataBasedOnPeremission,
          ]),
        );
        return [...filterPermittedDataBasedOnPeremission];
      }
    }
    return [];
  };

  const createMappedDataToRenderUI = (parameters = []) => {
    const localParameter = [...parameters];
    const currentYear = new Date().getFullYear();
    localParameter.filter((item) => {
      if (
        item?.dataType === 'Date' &&
        item?.isRequired === 'true' &&
        item?.defaultValue
      ) {
        const fullDate = new Date(item?.defaultValue);
        const date = fullDate.getDate();
        const month = fullDate.getMonth() + 1;
        const year = currentYear;
        const formattedDate = `${month}/${date}/${year}`;
        item.defaultValue = formattedDate;
      }
      return;
    });
    const groupDataArray = localParameter
      .filter((item) => {
        return (
          item?.group === 'Basics' &&
          (item?.name === 'eciColor' ||
            item?.name === 'eciTPAClient' ||
            item?.name === 'eciTPAName')
        );
      })
      .map((item) => item?.name);
    const optionalPagespDataArray = localParameter
      .filter((item) => {
        return (
          item?.group === 'Optional Pages' &&
          (item?.name === 'DisplayParameterPage' ||
            item?.name === 'Sample' ||
            item?.name === 'TitlePage')
        );
      })
      .map((item) => item?.name);
    const outputParameterDataArray = localParameter
      .filter((item) => {
        return (
          item?.group === 'Output Parameters' &&
          (item?.name === 'JavelinaStyle' || item?.name === 'PageNumberStyle')
        );
      })
      .map((item) => item?.name);
    const extraHidingFields = [
      'eciDebuggingLevel',
      'mSystem',
      'BOBbegin',
      'BOBend',
      'ClientBegin',
      'ClientEnd',
      'LocationBegin',
      'LocationEnd',
    ];

    const notToDisplayDynamicFieldsName = [
      ...groupDataArray,
      ...optionalPagespDataArray,
      ...outputParameterDataArray,
      ...extraHidingFields,
    ];

    const mappedParameterData = {
      mandatoryFields: [],
      optionalFields: [],
      productFields: [],
    };
    const mandatoryFieldsLocal = [];
    const optionalFieldsLocal = [];
    const productFields = [];
    if (localParameter?.length > 0) {
      localParameter.map((item) => {
        if (item?.isRequired === 'true' && item?.group !== 'Products') {
          mandatoryFieldsLocal.push({
            ...item,
            value: item?.defaultValue,
            isDisplay:
              notToDisplayDynamicFieldsName.filter(
                (notToDisplayItem) => notToDisplayItem === item?.name,
              ).length === 0,
          });
        } else if (item?.isRequired === 'false' && item?.group !== 'Products') {
          optionalFieldsLocal.push({
            ...item,
            value: item?.defaultValue,
            isDisplay:
              notToDisplayDynamicFieldsName.filter(
                (notToDisplayItem) => notToDisplayItem === item?.name,
              ).length === 0,
          });
        } else if (item?.group === 'Products') {
          productFields.push({
            ...item,
            value: item?.defaultValue,
            isDisplay:
              notToDisplayDynamicFieldsName.filter(
                (notToDisplayItem) => notToDisplayItem === item?.name,
              ).length === 0,
          });
        }
        return;
      });

      if (productFields && productFields.length > 0) {
        const products = productFields;
        products.map((data) => {
          switch (data.displayName) {
            case 'MM':
              data.displayName = 'Medical';
              break;
            case 'DE':
              data.displayName = 'Dental';
              break;
            case 'VI':
              data.displayName = 'Vision';
              break;
            case 'RX':
              data.displayName = 'Prescription';
              break;
            case 'FX':
              data.displayName = 'Flex';
              break;
            case 'DI':
              data.displayName = 'Disability';
              break;
            default:
              data.displayName = 'Others';
          }
          //if ( data.displayName==='MM' ) data.displayName='Medical';
          //if ( data.displayName==='DE' ) data.displayName='Dental';
          //if ( data.displayName==='VI' ) data.displayName='Vision';
          //if ( data.displayName==='RX' ) data.displayName='Prescription';
          //if ( data.displayName==='FX' ) data.displayName='Flex';
          //if ( data.displayName==='DI' ) data.displayName='Disability';

          return data;
        });
        console.log(products, 'products');
        optionalFieldsLocal.push(...products);
      }

      mappedParameterData.mandatoryFields = [...mandatoryFieldsLocal];
      mappedParameterData.optionalFields = [...optionalFieldsLocal];
    }
    return mappedParameterData;
  };

  const updateValueOnFieldChange = (
    isMandatoryField,
    nameOfTheField,
    updatedValueOfTheField,
  ) => {
    const mappedParameterData = {
      mandatoryFields: [...generateReport?.dynamicFieldsData?.mandatoryFields],
      optionalFields: [...generateReport?.dynamicFieldsData?.optionalFields],
    };
    if (isMandatoryField) {
      mappedParameterData.mandatoryFields =
        mappedParameterData.mandatoryFields.map((item) => {
          if (item?.name === nameOfTheField) {
            return { ...item, value: updatedValueOfTheField };
          } else {
            return { ...item };
          }
        });
    } else {
      mappedParameterData.optionalFields =
        mappedParameterData.optionalFields.map((item) => {
          if (item?.name === nameOfTheField) {
            return { ...item, value: updatedValueOfTheField };
          } else {
            return { ...item };
          }
        });
    }
    dispatch(setDynamicFields(mappedParameterData));
    return mappedParameterData;
  };

  /**
   * @method getReportCategoryAndName : get reports category or reports name based on reports category.
   * @param option : string | ('CATEGORY' or 'NAME')
   * @param selectedReportCategory : string | null
   * If we will call this fuction with first parameter 'CATEGORY' so we will get reports category data on redux state. (state.reports.generateReport.reportCategoryDropdownOptions).
   * If we will call this fuction with first parameter 'NAME' and second parameter as reportCategory like "Claim Processing" so we will get reports name for that category on redux state. (state.reports.generateReport.reportNameDropdownOptions).
   */

  const getReportCategoryAndName = async (
    option,
    selectedReportCategory = null,
  ) => {
    let URL = APIEndpoints.getReportsCategoryAndName();

    try {
      dispatch(setDynamicFields({ mandatoryFields: [], optionalFields: [] }));
      if (option === 'CATEGORY') {
        const response = await axiosInstance.get(URL);
        const DATA = response?.data?.Response?.reportsInformationDTOList;
        console.log(
          'option getReportCategoryAndName',
          response?.data?.Response,
        );
        getReportCategoryList(DATA);
        console.log('option :', option);
      }

      if (option === 'NAME') {
        URL += `/category/${selectedReportCategory?.label}`;
        const response = await axiosInstance.get(URL);
        const DATA = response?.data?.Response?.reportsInformationDTOList;
        getReportNameList(DATA);
      }
    } catch (error) {
      console.log('error', error);
      if (option === 'CATEGORY') {
        dispatch(setReportCategoryDropdownOptions([]));
      }
      if (option === 'NAME') {
        dispatch(setReportNameDropdownOptions([]));
      }
    }
  };

  const getDynamicFieldsData = async (reportData) => {
    dispatch(setIsServerErrorOnDynamicForm(false));
    const URL = APIEndpoints.getReportDynamicFields() + reportData?.value;
    dispatch(setDynamicFields({ mandatoryFields: [], optionalFields: [] }));
    try {
      const response = await axiosInstance.get(URL);
      const DATA = response?.data?.Response;
      const mappedData = createMappedDataToRenderUI(DATA?.parameters);
      console.log('getDynamicFieldsData', DATA, mappedData);
      dispatch(setDynamicFields(mappedData));
    } catch (error) {
      console.log('error :', error);
      dispatch(setDynamicFields({ mandatoryFields: [], optionalFields: [] }));
      dispatch(setIsServerErrorOnDynamicForm(true));
    }
  };

  const generateReportHandler = async (updatedValues) => {
    const URL =
      APIEndpoints.generateReport() +
      generateReport?.reportName?.reportName +
      (generateReport?.reportCategory
        ? `/module/${generateReport?.reportCategory?.label}`
        : '') +
      (userData?.Oid ? `/useroid/${userData?.Oid}` : '') +
      (userData?.UserID ? `/createdby/${userData?.UserID}` : '') +
      `/rox_pathnfile/${generateReport?.reportName?.value}`;
    const payload = updatedValues;
    try {
      const response = await axiosInstance.post(URL, payload);
      const toastSubMessage = (
        <div>
          The Report is being generated and may take up to 30 minutes. The
          Report will be available in the list once the process is complete.{' '}
          <b
            className="click-to-view-button"
            onClick={() => navigate('/admin/reports')}
          >
            Click to view.
          </b>
        </div>
      );
      if (response?.status === 201) {
        toast.success(
          <ToastMessage
            type="success"
            title="Your request has been submitted successfully."
            subTitle={toastSubMessage}
          />,
        );
      }
    } catch (error) {
      console.log('generateReportHandler error :', error);
      toast.error(
        <ToastMessage
          type="error"
          subTitle="Your request could not submitted successfully. Please try again!"
        />,
      );
    }
  };

  return {
    dispatch,
    getReportCategoryAndName,
    generateReport,
    setReportCategoryDropdownOptions,
    setReportNameDropdownOptions,
    setReportCategory,
    setReportName,
    resetGenerateReport,
    getDynamicFieldsData,
    updateValueOnFieldChange,
    generateReportHandler,
    resetBlobData,
  };
};
export default useGenerateReport;
